/**
 * Reports View
 */
export default () => ({
  path: '/reports',

  title: 'Reportes',

  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Reports = require('./containers/ReportsViewContainer').default
      const ToolbarFilters = require('../../components/ToolbarFilters').default
      const AlertStatusBar = require('../../components/AlertsStatusBar').default
      cb(null, {
        content: Reports,
        statusBar: AlertStatusBar,
        toolbarFilters: ToolbarFilters
      })
    }, 'reports')
  },
})



// WEBPACK FOOTER //
// ./src/routes/Reports/index.js